export const FINISHED_STATUS = ['FINISHED', 'SURPLUSWITHDRAWN'];
export const EXPOSED_STATUS = ['TRANSFERED', 'DEBT'];
export const DEBT_STATUS = ['DEBT'];
export const REJECTED_STATUS = ['REJECTED', 'REJECTEDRATIFICATION', 'REJECTEDTRANSFERED'];
export const EXPIRED_STATUS = ['EXPIRED'];
